import { ReactNode } from 'react';

// CardHeader component
export function CardHeader({ iconClass, title }: { iconClass?: string; title: string }) {
    return (
        <div className="card_header">
            <em className={`${iconClass} icon_large`}></em>
            <div><h3>{title}</h3></div>
        </div>
    );
}

// CardActions component
export function CardActions({ children }: { children?: ReactNode }) {
    return (
        <div className="card_actions">
            {children}
        </div>
    );
}

// Full Card component (optional, if you want to wrap everything together)
export function Card({ children, style }: { children: ReactNode, style?: React.CSSProperties }) {
    return (
        <section className="z2 card" style={style} >
            {children}
        </section>
    );
}

// Usage example inside your Products page:
//

